
export default class PreferencesController {

	constructor (
		$filter,
		$timeout,
		$scope,
		Brand,
		brand,
		marketer,
		Marketer,
		Session
	) {
		this.translate            = $filter('translate');
		this.$timeout             = $timeout;
		this.Brand                = Brand;
		this.brand                = brand;
		this.brandUpdates         = { ...brand };
		this.Marketer             = Marketer;
		this.marketerUpdates      = { ...marketer };
		this.activeScreen         = 0;
		this.displayOnMangootrust = brand.displayOnMangootrust;
		this.scope                = $scope;
		this.ratingIntervalSlider = {
			options: {
			    floor: 1,
				ceil: 5,
				step: 1,
				showTicks: true
			}
		};
		this.Session              = Session;
		this.Session.set('user', Object.assign(this.Session.get('user'), marketer));
		this.marketer             = this.Session.get('user');
		console.log(this.marketer);
	}

	setNpsNotifications () {
		this.marketerUpdates.npsNotifications = this.marketerUpdates.npsEmailNotificationDetractor
												|| this.marketerUpdates.npsEmailNotificationPassive
												|| this.marketerUpdates.npsEmailNotificationPromoter;
	}

	updateImage (key, id) {
		var file = document.getElementById(id).files[0];

		if (file) {
			var reader = new FileReader();

			reader.addEventListener("load", _ => this.$timeout(_ => {
				this.brandUpdates[key] = reader.result;
				this.brandUpdates[key+'File'] = file;
			}), false);

			reader.readAsDataURL(file);
		}
	}

	savePreferences () {
		if (this.activeScreen === 0 || this.activeScreen === 1) {
			this.displayOnMangootrust = this.brandUpdates.displayOnMangootrust;
			this.brand = Object.assign(this.brand, this.brandUpdates);
			this.Brand.update(this.brandUpdates);
		} else if (this.activeScreen == 2) {
			if (!this.marketerUpdates.npsNotifications) {
				this.marketerUpdates.npsEmailNotificationPassive = false;
				this.marketerUpdates.npsEmailNotificationDetractor = false;
				this.marketerUpdates.npsEmailNotificationPromoter = false;
			}
			this.Marketer.updateNotifications(this.marketerUpdates);
		}
	}

	setActiveScreen (index) {
		this.activeScreen = index;
		this.brandUpdates = { ...this.brand };
		this.marketerUpdates = { ...this.marketer };
	}

	showTipMangootrust () {
		swal({
			title: this.translate('CONTACT_MID_MANGOOTRUST_TITLE'),
			text: this.translate('CONTACT_MID_MANGOOTRUST_TEXT'),
			type: 'warning',
			showCancelButton: false
		});
	}

	showConfirmationMangootrust () {
		if (this.brand.displayOnMangootrust !== this.brandUpdates.displayOnMangootrust) {
			swal({
				title: '',
				text: this.translate('PUBLISH_ALL_MANGOOTRUST_TEXT'),
				type: 'info',
				showCancelButton: true,
				cancelButtonText: this.translate('CANCEL')
			}, (confirmed) => {
				if (!confirmed) {
					this.brandUpdates.displayOnMangootrust = false;
				}
				this.scope.$apply();
			});
		}
	}

}

PreferencesController.$inject = [
	'$filter',
	'$timeout',
	'$scope',
	'Brand',
	'brand',
	'marketer',
	'Marketer',
	'Session'
];



// WEBPACK FOOTER //
// ./src/page/preferences/preferences.controller.js